// Languages users can choose for transcription, shared by upload, recording
// and the default-language setting. Values are the codes the API accepts.
export const AUTO_DETECT = "auto";

export const TRANSCRIPTION_LANGUAGES = [
  { value: "en", label: "English (Global)" },
  { value: "en_us", label: "English (US)" },
  { value: "en_uk", label: "English (UK)" },
  { value: "en_au", label: "English (Australian)" },
  { value: "zh", label: "Chinese (Mandarin)" },
  { value: "nl", label: "Dutch" },
  { value: "fi", label: "Finnish" },
  { value: "fr", label: "French" },
  { value: "de", label: "German" },
  { value: "hi", label: "Hindi" },
  { value: "id", label: "Indonesian" },
  { value: "it", label: "Italian" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "pl", label: "Polish" },
  { value: "pt", label: "Portuguese" },
  { value: "ro", label: "Romanian" },
  { value: "ru", label: "Russian" },
  { value: "es", label: "Spanish" },
  { value: "tr", label: "Turkish" },
  { value: "uk", label: "Ukrainian" },
  { value: "vi", label: "Vietnamese" },
];

/**
 * The language list for a picker. A saved default that isn't in the list
 * (e.g. set in a mobile app with a longer list) is added so it can still be
 * shown and kept, instead of silently falling back to Auto-detect.
 */
export function languageOptions(savedLanguage) {
  const known = TRANSCRIPTION_LANGUAGES.some(
    (option) => option.value === savedLanguage,
  );
  if (!savedLanguage || savedLanguage === AUTO_DETECT || known) {
    return TRANSCRIPTION_LANGUAGES;
  }
  return [
    ...TRANSCRIPTION_LANGUAGES,
    { value: savedLanguage, label: languageLabel(savedLanguage) },
  ];
}

// A readable name for a code the list doesn't have ("ar" → "Arabic");
// falls back to the code itself.
function languageLabel(code) {
  try {
    const name = new Intl.DisplayNames(["en"], { type: "language" }).of(
      code.replace("_", "-"),
    );
    if (name) return name;
  } catch {
    // Not a valid language tag: show the code.
  }
  return code;
}

/** Where a picker starts: the saved default, else Auto-detect. */
export function initialLanguage(savedLanguage) {
  return savedLanguage || AUTO_DETECT;
}

/**
 * The `language` to send for one upload or recording.
 *
 * A chosen language is sent as is. Auto-detect needs care: when a request has
 * no language, the server uses the user's saved default, so Auto-detect is
 * sent explicitly as "auto" unless we know there's no saved default
 * (savedLanguage === null). Then nothing is sent, as before. `undefined`
 * means the default couldn't be loaded, so "auto" is sent to be safe.
 */
export function languageForRequest(selected, savedLanguage) {
  if (selected && selected !== AUTO_DETECT) return selected;
  return savedLanguage === null ? undefined : AUTO_DETECT;
}
